import {
  Box,
  Button,
  Divider,
  TextInput,
  Typography,
} from "@strapi/design-system";
import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword, getProfile } from "../util/API";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../redux/action/app";

const ResetPassword = ({ lng = "vi" }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [confirmation, setConfirmation] = useState(null);
  const [is_nominatee, setIsNominatee] = useState(false);
  const [password, setPassword] = useState(null);
  const [passwordConfirmation, setPasswordConfirmation] = useState(null);
  const [email, setEmail] = useState(null);
  const [code, setCode] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.has("code")) {
      setCode(searchParams.get("code").replace(" ", "+"));
    } else {
      //Alert thông báo confirmation in valid
      messageApi.open({
        type: "error",
        content: t("str_email_comfirmation.invalid"),
      });
    }
  }, []);

  useEffect(() => {
    if (lng) {
      i18n.changeLanguage(lng);
    }
  }, [lng]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const checkValid = isValid();
    if (!checkValid) {
      messageApi.open({
        type: "error",
        content: t("str_fill_in_all_info"),
      });
      return;
    }

    if (password != passwordConfirmation) {
      messageApi.open({
        type: "error",
        content: t("str_password_not_match"),
      });
      return;
    }

    try {
      const response = await resetPassword({
        passwordConfirmation,
        password,
        code,
      });

      if (response.status === 200) {
        const { user, jwt } = response.data;
        localStorage.setItem("token", jwt);
        localStorage.setItem("user", user);
        await getUserInfo();
        if (lng === "en") navigate(`/nomination/profile`);
        else navigate(`/nomination/ho-so`);
      }
    } catch (error) {}
  };

  const getUserInfo = async () => {
    try {
      const response = await getProfile();
      dispatch(setUserInfo(response.data));
    } catch (error) {
      console.error(error);
      // TODO: Handle error while fetching profile
    }
  };

  //#region Validation
  const isValid = () => {
    if (password === "") return false;
    if (passwordConfirmation === "") return false;
    return true;
  };
  //#endregion

  return (
    <div>
      {contextHolder}
      <Box padding={4}>
        <Typography variant="alpha" style={{ textAlign: "center" }}>
          {t("str_reset_password")}
        </Typography>
      </Box>
      <Divider />
      <Box padding={4}>
        <TextInput
          name="password"
          label={t("str_password")}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <br />
        <TextInput
          value={passwordConfirmation}
          name="confirm_password"
          label={t("str_confirm_password")}
          type="password"
          onChange={(e) => setPasswordConfirmation(e.target.value)}
        />
        <br />
        <Button color="primary" type="submit" onClick={handleSubmit}>
          {t("str_confirm")}
        </Button>
      </Box>
    </div>
  );
};

export default ResetPassword;
